/**
 * Ashley Interface v1 entry point — operational voice layer on FAB long-press.
 */

import { ashleyLog } from "../ashley/debug/ashleySttDebug";
import { voiceDiag, msSinceLastGesture } from "../ashley/debug/ashleyVoiceDiagnostics";
import {
  isAshleySpeechUnlocked,
  unlockAshleySpeech,
} from "../ashley/speech/ashleySpeech";

export const ASHLEY_INTERFACE_OPEN_EVENT = "cp-ashley-interface-open";
export const ASHLEY_INTERFACE_CLOSED_EVENT = "cp-ashley-interface-closed";
export const ASHLEY_LAUNCH_GESTURE = Object.freeze({
  TAP: "tap",
  LONG_PRESS: "long-press",
});

/** Blocks backdrop / release-click dismissal until the launch pointer gesture ends. */
let longPressLaunchGuardsActive = false;

export function armAshleyLongPressLaunchGuards() {
  longPressLaunchGuardsActive = true;
}

export function isAshleyLongPressLaunchGuardActive() {
  return longPressLaunchGuardsActive;
}

export function releaseAshleyLongPressLaunchGuards() {
  longPressLaunchGuardsActive = false;
}

export function launchAshleyInterface(options = {}) {
  if (options.launchGesture === ASHLEY_LAUNCH_GESTURE.LONG_PRESS) {
    armAshleyLongPressLaunchGuards();
  }

  // iOS WebKit: first speechSynthesis.speak() must run inside this gesture.
  // Greeting TTS is issued later in the same stack (no await); unlock also
  // covers later acknowledgement speaks in this document session.
  unlockAshleySpeech();

  ashleyLog("Interface launched");
  voiceDiag("Voice init started (launchAshleyInterface)", {
    hypothesisId: "H-A",
    location: "ashleyInterfaceLauncher.launchAshleyInterface",
    data: {
      msSinceGesture: msSinceLastGesture(),
      launchGesture: options.launchGesture || ASHLEY_LAUNCH_GESTURE.TAP,
      speechUnlocked: isAshleySpeechUnlocked(),
    },
  });
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  window.dispatchEvent(
    new CustomEvent(ASHLEY_INTERFACE_OPEN_EVENT, {
      detail: options,
    }),
  );
}
